import { render } from "./RecordsEmpty.vue?vue&type=template&id=8c0a00b8"
import script from "./RecordsEmpty.vue?vue&type=script&lang=js"
export * from "./RecordsEmpty.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.18.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__